module.exports = __webpack_public_path__ + "static/media/IL.bc76641c.svg";